import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminProjectInformationTypes = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PROJECT_INFORMATION_TYPES.GET_ALL, { params });
    return response.data;
};

export const getAdminProjectInformationTypeById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PROJECT_INFORMATION_TYPES.GET_BY_ID(id));
    return response.data;
};

export const createProjectInformationType = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.PROJECT_INFORMATION_TYPES.CREATE, data);
    return response.data;
};

export const updateProjectInformationType = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.PROJECT_INFORMATION_TYPES.UPDATE(id), data);
    return response.data;
};

export const deleteProjectInformationType = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.PROJECT_INFORMATION_TYPES.DELETE(id));
    return response.data;
};
